import axios from "../../axios";
import { Commit, Dispatch } from 'vuex'

const baseURL = "/plip_reports";

export default ({
    namespaced: true,
    state : {
        plip_report: [],
        item:{},
        status: 'loading'
    },
    actions : {
        async index({commit}: {commit: Commit}, payload={}){
            commit('SET_STATUS', 'loading')
            const { data } = await axios.get(`${baseURL}`, {params: {...payload}});
            commit('SET_ITEMS', data)
            commit('SET_STATUS', 'completed')
            return data
        },
        
        async store({dispatch}: {dispatch: Dispatch}, payload={}){
            const { data } = await axios.post(`${baseURL}`, payload);
            dispatch('index')
            return data
        },

        async update({dispatch}: {dispatch: Dispatch}, {id="",payload={}}){
            const { data } = await axios.post(`${baseURL}/${id}`, payload);
            dispatch('index')
            return data
        },

        async destroy({dispatch}: {dispatch: Dispatch}, id=""){
            const { data } = await axios.delete(`${baseURL}/${id}`);
            dispatch('index')
            return data
        }

    },
    mutations:{
        SET_ITEMS(state:any, data: any){
            state.plip_report = data.data;
        },
        SET_STATUS(state: any, payload: string){
            state.status = payload;
        },
    },
    getters:{
        items(state: any){
            return state.plip_report;
        },
        status(state: any){
            return state.status;
        }
    }
});




